<template>
  <v-dialog :model-value="modelValue" persistent width="360">
    <v-card>
      <v-card-text>
        <div class="text-center mb-3">{{ stageLabel }}</div>
        <v-progress-linear
          :indeterminate="!determinate"
          :model-value="percent"
          color="primary"
          height="8"
          rounded
        ></v-progress-linear>
        <div v-if="determinate" class="text-center text-caption mt-2">
          {{ done.toLocaleString() }} / {{ total.toLocaleString() }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue';

// Determinate progress for the file-processing pipeline
// (SpreadsheetProcessor.processFile onProgress events). Stages without
// done/total (single blocking calls like DOMParser) render indeterminate.
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  stage: {
    type: String,
    default: ''
  },
  done: {
    type: Number,
    default: null
  },
  total: {
    type: Number,
    default: null
  }
});

const STAGE_LABELS = {
  'scanning-calendars': 'Matching P6 calendars…',
  'reading-file': 'Reading file…',
  'reading-workbook': 'Reading workbook…',
  'parsing-xml': 'Parsing XML…',
  'tasks': 'Reading tasks…',
  'relationships': 'Reading relationships…',
  'hierarchy': 'Building hierarchy…',
  'rows': 'Processing rows…',
  'comparing': 'Comparing with existing schedule…'
};

const stageLabel = computed(() => STAGE_LABELS[props.stage] || 'Processing…');
const determinate = computed(() => props.total != null && props.total > 0 && props.done != null);
const percent = computed(() => determinate.value ? (props.done / props.total) * 100 : 0);
</script>
